/**
 * Device Status Store
 *
 * @since 2018-11-06
 * @author mk.ko
 */
import JSONBigInt from 'json-bigint'

export const state = () => ({
  eventLogFilter: {}, // 이벤트 필터
  // 미복구 이벤트
  eventLogData: [],
  // 이벤트 로그 (최근 24시간)
  eventLogData24: [],
  eventLogCnt: 0,
  eventPopupData: [],
  eventPopupInitData: [],
  maxObjectLogId: 0
})

export const mutations = {
  initDeviceStore (state) {
    state.eventLogData = Object.freeze([])
    state.eventLogData24 = Object.freeze([])
    state.eventLogCnt = 0
  },
  setEventPopupOriginData (state, payload) {
    // 페이지 최초 진입 시 이벤트 팝업창에 출력할 데이터가 없으니깐, 최초에 비교할 수 있는 원본 데이터가 필요
    // 이벤트 로그 id가 없을 경우(페이지 첫 진입시 최초 api 응답값) payload 값을 넣는다
    const newData = [] // 미복구 이벤트 신규 데이터
    // 최초에는 max event_log_id 값이 없으므로 payload 값을 prevData에 초기화 한다
    const prevData = state.maxObjectLogId === 0 ? payload : state.eventPopupInitData
    if (state.maxObjectLogId > 0) {
      payload.forEach(item => {
        if (item.event_log_id > state.maxObjectLogId) {
          newData.push(item)
        }
      })
      state.eventPopupData = newData
    }
    state.eventPopupInitData = state.maxObjectLogId === 0 ? prevData : payload
    // 신규 데이터 event_log_id 값은 항상 기존 데이터보다 id값이 큼
    if (state.eventPopupInitData.length !== 0) {
      // 신규 데이터가 없을때는 id를 찾을 수 없기 때문에 예외처리가 필요함
      const evtId = _.get(state.eventPopupInitData, [0, 'event_log_id'], state.maxObjectLogId)
      state.maxObjectLogId = state.eventPopupInitData.reduce((max, obj) => (obj.event_log_id > max.event_log_id ? obj : max), evtId)
    }
  },
  setEventLogData (state, payload) {
    state.eventLogData = Object.freeze(payload)
  },
  setEventLogData24 (state, payload) {
    state.eventLogData24 = Object.freeze(payload)
  },
  setEventLogDataCnt (state, payload) {
    state.eventLogCnt = payload
  },
  setEventLogDataFilter (state, {tableKey, filters}) {
    _.set(state.eventLogFilter, [tableKey], _.cloneDeep(filters))
  }
}
export const actions = {
  async getDeviceStatusData ({ state, commit }, params) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      // Axios 호출
      const apiUrl = `/api/da/dashboard/device-status`
      res = await this.$axios.$post(apiUrl, params, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async getEventLogPopUpData ({ state, commit }, { deviceIdList }) {
    const apiUrl = `/api/da/dashboard/device-status/cur-event-log`
    const filters = _.get(state.eventLogFilter, ['eventGridTable', 'event_level_name'], {})
    const filterArr = _.filter(Object.keys(filters), filterKey => {
      return filters[filterKey]
    })
    let eventLevelTypeList = _.map(filterArr, o => Number(o))
    if (_.size(eventLevelTypeList) === 0) eventLevelTypeList = [1, 2, 3, 4, 5]
    try {
      const {code, result} = await this.$axios.$post(apiUrl, {
        device_id_list: deviceIdList,
        event_level_type_list: eventLevelTypeList
      }, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })

      if (code === 'ok') {
        commit('setEventPopupOriginData', result)
      }
    } catch (e) {
      this.$log('[Error setEventPopupOriginData]: ', e)
      commit('setEventPopupOriginData', [])
    }
  },
  // 미복구 이벤트
  async getEventLogData ({ state, commit }, { deviceIdList }) {
    const apiUrl = `/api/da/dashboard/device-status/cur-event-log`
    const filters = _.get(state.eventLogFilter, ['eventGridTable', 'event_level_name'], {})
    const filterArr = _.filter(Object.keys(filters), filterKey => {
      return filters[filterKey]
    })
    let eventLevelTypeList = _.map(filterArr, o => Number(o))
    if (_.size(eventLevelTypeList) === 0) eventLevelTypeList = [1, 2, 3, 4, 5]
    try {
      const {code, result} = await this.$axios.$post(apiUrl, {
        device_id_list: deviceIdList,
        event_level_type_list: eventLevelTypeList
      }, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })

      if (code === 'ok') {
        commit('setEventLogData', result)
      }
    } catch (e) {
      this.$log('[Error getEventLogData]: ', e)
      commit('setEventLogData', [])
    }
  },
  // 이벤트 로그 (최근 24시간)
  async getEventLogData24 ({ commit, state }, { deviceIdList, pagePos, pageSize }) {
    const apiUrl = `/api/da/dashboard/device-status/event-log-new`
    const filters = _.get(state.eventLogFilter, ['eventGrid24Table', 'event_level_name'], {})
    const filterArr = _.filter(Object.keys(filters), filterKey => {
      return filters[filterKey]
    })
    let eventLevelTypeList = _.map(filterArr, o => Number(o))
    if (_.size(eventLevelTypeList) === 0) eventLevelTypeList = [1, 2, 3, 4, 5]
    try {
      const {code, result} = await this.$axios.$post(apiUrl, {
        device_id_list: deviceIdList,
        event_level_type_list: eventLevelTypeList,
        page_pos: pagePos,
        page_cnt: pageSize
      }, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })

      if (code === 'ok') {
        commit('setEventLogData24', result)
      }
    } catch (e) {
      this.$log('[Error getEventLogData24]: ', e)
      commit('setEventLogData24', [])
    }
  },
  async getEventLogDataCnt ({ commit, state }, { deviceIdList }) {
    const apiUrl = `/api/da/dashboard/device-status/event-log-cnt`
    const filters = _.get(state.eventLogFilter, ['eventGrid24Table', 'event_level_name'], {})
    const filterArr = _.filter(Object.keys(filters), filterKey => {
      return filters[filterKey]
    })
    let eventLevelTypeList = _.map(filterArr, o => Number(o))
    if (_.size(eventLevelTypeList) === 0) eventLevelTypeList = [1, 2, 3, 4, 5]
    try {
      const {code, result} = await this.$axios.$post(apiUrl, {
        device_id_list: deviceIdList,
        event_level_type_list: eventLevelTypeList
      }, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })

      if (code === 'ok') {
        commit('setEventLogDataCnt', result[0].cnt)
      }
    } catch (e) {
      this.$log('[Error getEventLogDataCnt]: ', e)
      commit('setEventLogDataCnt', 0)
    }
  }
}

export const getters = {}
export const strict = false
